<div id="score-level-badge" [title]="'Your score is ' + publicScore">
  <div class="pallete" appScoreLevelBgColor [publicScore]="publicScore"></div>
  <div>{{ publicScore | scoreLevelTitle }}</div>
</div>
